import HooverHeroSection from "./components/HeroSection";
import HooverStickyNav from "./components/StickyNav";
import HooverProcessingTimeSection from "./components/ProcessingTimeSection";
import HooverServicesSection from "./components/ServicesSection";
import HooverLocalAreaSection from "./components/LocalAreaSection";
import HooverTravelTimingSection from "./components/TravelTimingSection";
import HooverDestinationsSection from "./components/DestinationsSection";
import HooverTestimonialsSection from "./components/TestimonialsSection";
import HooverAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HooverComparisonSection from "./components/ComparisonSection";
import HooverMistakesSection from "./components/MistakesSection";
import HooverHowItWorksSection from "./components/HowItWorksSection";
import HooverFAQSection, { faqs } from "./components/FAQSection";
import HooverHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HooverFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

export default function HooverPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Hoover"
        state="Alabama"
        stateAbbr="AL"
        route="/cities/hoover"
        title="Emergency Passport Hoover, AL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Hoover, AL — as fast as 24 hours. Serving Riverchase executives, Vestavia Hills professionals, and Greater Birmingham south suburbs. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Hoover, Alabama"
        geoPosition="33.4050;-86.8113"
        faqs={faqsMapped}
        servicesSchema={[]}
        statePageName="Alabama"
        statePageRoute="/states/alabama"
      />
      <HooverHeroSection />
      <HooverStickyNav />
      <HooverProcessingTimeSection />
      <HooverLocalAreaSection />
      <HooverServicesSection />
      <HooverTravelTimingSection />
      <HooverDestinationsSection />
      <HooverTestimonialsSection />
      <HooverAcceptanceFacilitiesSection />
      <HooverComparisonSection />
      <HooverMistakesSection />
      <HooverHowItWorksSection />
      <HooverFAQSection />
      <HooverHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/hoover" state="AL" />
      <HooverFinalCTA />
    </div>
  );
}